<template>
  <div v-if="gameConfig">
    <div class="row">
      <label class="form-control-label">
        <h4>Game Instance Duration</h4>
      </label>
    </div>
    <div class="row">
      <label class="d-inline mx-10 form-control-label">
        Start
      </label>
      <div class="d-inline mx-10">
        <DatePicker
          type="datetime"
          width-200px
          @confirm="update('start_date')"
          :confirm="true"
          :clearable="false"
          placeholder="n/a"
          ref="start_date"
          format="YYYY-MM-DD HH:mm:ss"
          value-type="format"
          :disabled-date="disabledBeforeToday"
          :disabled="disabled"
          v-model="gameConfig.start_date"
          :show-time-panel="showTimePanelStart"
          ><template v-slot:footer>
            <button
              class="mx-btn mx-btn-text"
              @click="showTimePanelStart = !showTimePanelStart"
            >
              {{ showTimePanelStart ? "select date" : "select time" }}
            </button>
          </template></DatePicker
        >
      </div>
      <label class="d-inline mx-10 form-control-label">
        End
      </label>
      <div class="d-inline mx-10">
        <DatePicker
          type="datetime"
          width-200px
          @confirm="update('end_date')"
          @clear="update('end_date')"
          :confirm="true"
          placeholder="n/a"
          ref="end_date"
          format="YYYY-MM-DD HH:mm:ss"
          value-type="format"
          :disabled="!['draft', 'paused'].includes(gameConfig.status)"
          v-model="gameConfig.end_date"
          :disabled-date="disabledBeforeStart"
          :show-time-panel="showTimePanelEnd"
          ><template v-slot:footer>
            <button
              class="mx-btn mx-btn-text"
              @click="showTimePanelEnd = !showTimePanelEnd"
            >
              {{ showTimePanelEnd ? "select date" : "select time" }}
            </button>
          </template></DatePicker
        >
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import { gameService } from "@/api/client";

const httpService = gameService.axiosInstance;

export default {
  props: ["gameConfig"],

  components: {
    DatePicker,
  },

  data() {
    return {
      oldValue: null,
      end_date: null,
      start_date: null,
      showTimePanelEnd: false,
      showTimePanelStart: false,
    };
  },

  computed: {
    disabled() {
      return this.gameConfig.status != "draft";
    },
  },

  mounted() {
    this.oldValue = Object.assign({}, this.gameConfig);
  },

  methods: {
    disabledBeforeToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },

    disabledBeforeStart(date) {
      const startDate = new Date(this.gameConfig.start_date);
      startDate.setHours(0, 0, 0, 0);
      return date < startDate;
    },

    async isFormValid(field) {
      const { start_date, end_date } = this.gameConfig;

      switch (field) {
        case "start_date":
          if (moment(new Date()) > moment(start_date)) {
            await this.$dialogs.alert(
              "Start date ใส่ค่าได้ตั้งแต่วันเวลาที่ในอนาคตเท่านั้น"
            );

            this.$refs.start_date.focus();
            start_date = this.oldValue.start_date;

            return false;
          }

          if (moment(start_date) > moment(end_date)) {
            await this.$dialogs.alert(
              "กรุณาระบุวันเวลาเริ่มที่น้อยกว่าวันสิ้นสุด"
            );

            this.$refs.start_date.focus();
            start_date = this.oldValue.start_date;

            return false;
          }

          return true;

        case "end_date":
          if (moment(start_date) > moment(end_date)) {
            await this.$dialogs.alert(
              "กรุณาระบุวันเวลาเริ่มที่น้อยกว่าวันเวลาสิ้นสุด"
            );

            this.$refs.end_date.focus();
            this.gameConfig.end_date = this.oldValue.end_date;

            return false;
          }

          return true;

        default:
          return false;
      }
    },

    async update(field) {
      this.showTimePanelEnd = false;
      this.showTimePanelStart = false;

      try {
        const formValid = await this.isFormValid(field);
        if (!formValid) return;

        const id = this.gameConfig.id;
        const body = this.getFormData(field);

        await httpService.put(`/game/${id}`, body);

        this.oldValue = Object.assign({}, this.gameConfig);

        this.$emit("updated");
        this.$notify(`Game Instance Duration updated.`);
      } catch (error) {
        this.$dialogs.alert(`Game Instance Duration update error.`);
      }
    },

    getFormData(field) {
      switch (field) {
        case "end_date":
          return {
            end_date: this.gameConfig.end_date,
          };

        case "start_date":
          return {
            start_date: this.gameConfig.start_date,
          };

        default:
          return null;
      }
    },
  },
};
</script>

<style></style>
